import { LayerData } from '../data/configurator/layer/layer.data';

export class LabelEvent {

  static ADD_LAYER: string = 'LabelAddLayer'
  static UPDATE_LAYER: string = 'LabelUpdateLayer'
  static REMOVE_LAYER: string = 'LabelRemoveLayer'
  static REORDER_LAYERS: string = 'LabelReorderLayer'
  static CHANGE: string = 'LabelChange'
  static INIT_EMPTY: string = 'LabelInitEmpty'

  public type: string;
  public data: LayerData;

  /**
   * Constructor
   */
  constructor(type: string, layerData:LayerData) {
    this.type = type;
    this.data = layerData;
  }
}
